import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Button, Col, Row, Image } from "react-bootstrap";
import { NavLink, useHistory, useParams } from "react-router-dom";
import { Menu, MenuItem } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  get_single_page,
  update_experiences_in_section_from_pages,
} from "../../../../../store/actions/Experience/adminExperienceAction";
import NoContent from "../../../../reusableComponents/NoContentComponent";
import moment from "moment";
import { ReusableSlidingSearchComponent } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
import { Toggle } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";

const PageSections = (props) => {
  const dispatch = useDispatch();
  const { page_id } = useParams();
  const history = useHistory();
  const auth = useSelector((state) => state.auth);

  const page = useSelector((state) =>
    state?.superAdminExperience?.pages.filter((e) => e?._id === page_id)
  );

  const getPages = () => {
    dispatch(get_single_page(auth?.user?.accessToken, page_id));
  };
  useEffect(() => {
    if (!page?.length || !page[0]?.sections?.length) getPages();
  }, []);

  const changeHandler = (status, _id, type) => {
    update_experiences_in_section_from_pages(
      page_id,
      {
        status: status,
        section_id: _id,
      },
      auth?.user?.accessToken,
      "STATUS",
      getPages,
      "SECTION"
    );
  };
  /*********************************
   * @DESC SEARCH ACTION
   *********************************/
  const [search, setSearch] = useState("");
  const [isActive, setActive] = useState(false);
  const onChange = async (value) => {
    // console.log(value);
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userSort, setUserSort] = useState(0);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  /*********************************
   * @DESC DOWNLOAD ACTION
   *********************************/
  const downloadData = {
    headers: [
      { label: "Page ID", key: "PageID" },
      { label: "Page Description", key: "PageDescription" },
      { label: "Section ID", key: "SectionID" },
      { label: "Section Position", key: "SectionPosition" },
      { label: "Section Description", key: "SectionDescription" },
      { label: "Date Created", key: "DateCreated" },
    ],
    data:
      page[0]?.sections?.map((section) => {
        return {
          PageID: `${page[0]?.page_id || ""}`,
          PageDescription: `${page[0]?.description || ""}`,
          SectionID: `${section?.section_id || ""}`,
          SectionPosition: `${section?.position || ""}`,
          SectionDescription: `${section?.description || ""}`,
          DateCreated: `${
            section?.createdAt
              ? moment(section?.createdAt).format("Do MMM YYYY")
              : ""
          } ${
            section?.createdAt
              ? moment(section?.createdAt).format("hh:mm A")
              : ""
          }`,
        };
      }) || [],
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Add Section to {props?.location?.state}
                  <br />
                </div>
              </div>
              <div className="d-flex justify-content-end align-items-center">
                <div className="text-right">
                  <NavLink
                    to={`/superadmin/experience/section/${page_id}`}
                    className="mr-4 px-5 py-2 btn addBtnRed f14-700"
                    style={{ color: "#f26856" }}
                  >
                    Add Section
                  </NavLink>
                </div>
              </div>
              <Row>
                <Col md={5}>
                  <div className="d-flex  align-items-center justify-content-start">
                    <ReusableSlidingSearchComponent
                      placeholder={"Search by Description"}
                      isActive={isActive}
                      setActive={setActive}
                      setSearch={setSearch}
                      search={search}
                      onChange={onChange}
                    />
                    <div className="f10-400" align="center">
                      <div>
                        <div
                          className="f10-400"
                          align="center"
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                        >
                          <img
                            src={require("../../../../../assets/images/iconButton/sortbtn.svg")}
                            width="80px"
                          />
                        </div>
                        <Menu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                        >
                          {[
                            { title: "Sort by", value: 0, disabled: true },
                            {
                              title: `Date & Time 🠑`,
                              value: 1,
                              disabled: false,
                            },
                            {
                              title: "Date & Time 🠓",
                              value: 2,
                              disabled: false,
                            },
                          ].map((ele, index) => {
                            return (
                              <MenuItem
                                value={ele.value}
                                key={index}
                                onClick={() => setUserSort(ele.value)}
                                disabled={ele.disabled}
                                style={{ fontWeight: "700" }}
                              >
                                {ele.title}
                              </MenuItem>
                            );
                          })}
                        </Menu>
                      </div>
                    </div>

                    <CSVDownloader
                      filename={"Page Sections"}
                      headers={downloadData.headers}
                      data={downloadData.data}
                    />
                  </div>
                </Col>
                <Col md={4}></Col>
                <Col md={4}></Col>
              </Row>
              <div className="Row">
                <div
                  className={`mr-4 px-0 text-grayLink f12-700 btn btn-link active`}
                >
                  Add Sections to Pages
                </div>
              </div>
              <hr className="p-0 m-0" />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main mt-2">
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "15%" }} className="f12-400">
                        Page ID
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Page Description
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Section ID
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Section Position
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Section Description
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Date Created / Changed
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Active
                      </td>
                      <td style={{ width: "10%" }} className="f12-400"></td>
                    </tr>
                  </thead>
                  <tbody className="w-100 super-admin-all-vendor-main-table-body">
                    {page?.length && page[0]?.sections?.length ? (
                      page[0]?.sections
                        .filter((e) => {
                          if (search) {
                            if (
                              e?.description
                                .toLowerCase()
                                .includes(search.toLowerCase())
                            )
                              return true;
                          } else {
                            return true;
                          }
                        })
                        .sort((a, b) => {
                          if (userSort == 1) {
                            return (
                              new Date(a.createdAt) - new Date(b.createdAt)
                            );
                          } else if (userSort == 2) {
                            return (
                              new Date(b.createdAt) - new Date(a.createdAt)
                            );
                          }
                        })
                        .map((section) => {
                          return (
                            <Body
                              section={section}
                              page={page}
                              changeHandler={changeHandler}
                              history={history}
                              page_id={page_id}
                            />
                          );
                        })
                    ) : (
                      <NoContent />
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PageSections;

const Body = ({ section, page, changeHandler, history, page_id }) => {
  const [show, setShow] = useState(false);
  return (
    <tr className="w-100 p-0">
      <td className="p-0 w-100">
        <table className="w-100">
          <tbody className="sd_body_css">
            <tr
              className="pl-1"
              onClick={() => setShow(!show)}
              style={{ cursor: "pointer" }}
            >
              <td style={{ width: "15%" }}>
                <div>
                  <h5 className="font_16_m mt-3">{page[0]?.page_id || ""}</h5>
                </div>
              </td>
              <td style={{ width: "20%" }}>
                <h3 className="font_20_m">{page[0]?.description || ""}</h3>
              </td>
              <td style={{ width: "10%" }}>
                <h3 className="font_20_m">{section?.section_id || ""}</h3>
              </td>
              <td style={{ width: "10%" }}>
                <h3 className="font_20_m">{section?.position || ""}</h3>
              </td>
              <td style={{ width: "20%" }}>
                <h3 className="font_20_m">{section?.description || ""}</h3>
              </td>
              <td style={{ width: "20%" }}>
                <h3 className="font_20_m">
                  {section?.createdAt
                    ? moment(section?.createdAt).format("Do MMM YYYY")
                    : ""}
                  <br />

                  {section?.createdAt
                    ? moment(section?.createdAt).format("hh:mm A")
                    : ""}
                </h3>
              </td>
              <td style={{ width: "10%" }}>
                <h3 className="font_20_m">
                  <Toggle
                    toggleFunction={() =>
                      changeHandler(!section?.status, section?.section_id)
                    }
                    checked={section?.status}
                  />
                </h3>
              </td>
              <td style={{ width: "10%" }}>
                <Button
                  variant="danger"
                  onClick={() =>
                    history.push(
                      `/superadmin/experience/page/section/expsinsection/${page_id}/${section?.section_id}`
                    )
                  }
                >
                  Edit
                </Button>
              </td>
            </tr>
            {show && (
              <>
                <tr className="sd_accordion_body p-1">
                  <td style={{ width: "20%" }}>
                    <div className="f12-400">More Actions</div>
                    <div className="d-flex align-items-center mt-2">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={() =>
                          history.push(
                            `/superadmin/experience/section/${page_id}/edit/${section?._id}`
                          )
                        }
                      >
                        <Image
                          src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                      {/* <SuperAdminDeleteExpCurationPage
                          id={data?._id}
                          onSuccess={onSuccessDelete}
                          active={data?.status}
                          title="Request for Deletion"
                          subTitle="Are you sure you want to delete this Page ID?"
                        /> */}
                    </div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="f12-400">Total Number of Experiences</div>
                    {/* <div className="f12-500 mt-3">{data?.sections_count || 0}</div> */}
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </td>
    </tr>
  );
};
